import * as z from 'zod/v4';
import { zodResolver } from '@hookform/resolvers/zod';
import { FieldValues, type UseFormProps, useForm } from 'react-hook-form';

// prevent Zod to use eval() & new Function()
z.config({ jitless: true });

export function useZodForm<
    T extends z.ZodType<FieldValues, FieldValues>,
    TContext,
>(
    schema: T,
    props?: Omit<UseFormProps<z.input<T>, TContext, z.output<T>>, 'resolver'>,
) {
    return useForm({
        resolver: zodResolver(schema),
        ...props,
    });
}

export default z;
